import request from '../request'
import qs from 'qs'
// //自助理赔进度查询
const getICalimsInfo = (data) => {
  return request.post(`/api/wx/auth/getICalimsInfo?${qs.stringify(data)}`, data)
}
// 自助理赔申请删除
const claimCancel = (data) => {
  return request.post(`/api/wx/auth/claimCancel?${qs.stringify(data)}`, data)
}
// 自助案件详情
const getAppDetilInfo = (data) => {
  return request.post(
    `/api/wx/auth/calimApp/getAppDetilInfo?${qs.stringify(data)}`,
    data
  )
}
// 自助理赔详情
const getClaimsDetail = (data) => {
  return request.post(
    `/api/wx/auth/getClaimsDetail?${qs.stringify(data)}`,
    data
  )
}
// 理赔材料补充
const calimApppatch = (data) => {
  return request.post(`/api/wx/auth/calimApp/patch`, data)
}
// 获取补件类型列表
const getPreAppbjFileList = (data) => {
  return request.post('/api/wx/auth/preLicensing/getPreAppbjFileList', data)
}
// 获取预授权理赔正式案件补件列表
const getPrePatchFileType = (data) => {
  return request.post('/api/wx/auth/preLicensing/getPrePatchFileType', data)
}
// 获取理赔上传的文件列表
const queryClaimUploadedFiles = (data) => {
  return request.post('/api/wx/auth/calimApp/getClaimAppFileList', data)
}
// 获取预授权上传的文件列表
const queryPreAuthUploadedFiles = (data) => {
  return request.post('/api/wx/auth/preLicensing/getAuthFileList', data)
}
// 查询理赔解释
const getEobData = (data) => {
  return request.post(`/api/wx/auth/getEobData?${qs.stringify(data)}`, data)
}
// 自助理赔服务指南下载
const CgetServiceTemplate = (data) => {
  return request.post(
    `/api/wx/auth/calimApp/getServiceTemplate?${qs.stringify(data)}`,
    data
  )
}
// 邮件发送自助理赔服务指南
const CserviceSendMail = (data) => {
  return request.post(
    `/api/wx/auth/calimApp/serviceSendMail?${qs.stringify(data)}`,
    data
  )
}
// 自助理赔材料补充列表
const getCalimsAppPatchFileList = (data) => {
  return request.post('/api/wx/auth/calimApp/getCalimsAppPatchFileList', data)
}
// 自助理赔单证下载
const CgetTemplate = (data) => {
  return request.post(
    `/api/wx/auth/calimApp/getTemplate?${qs.stringify(data)}`,
    data
  )
}
// 邮件发送自助理赔单证
const CSendMail = (data) => {
  return request.post(
    `/api/wx/auth/calimApp/SendMail?${qs.stringify(data)}`,
    data
  )
}
// 自动理赔申请
const createIclaims = (data) => {
  return request.post('/api/wx/auth/createIclaims', data)
}
// 预览自动理赔申请
const previewIclaims = (data) => {
  return request.post('/api/wx/auth/getCAInfo', data)
}
// 查询国家
const getSycCtryList = (data) => {
  return request.post('/api/wx/getSycCtryList', data)
}
// 查询省

const getSycStateList = (data) => {
  return request.post('/api/wx/getSycStateList', data)
}
// 查询市
const getSycDistList = (data) => {
  return request.post('/api/wx/getSycDistList', data)
}
// 查询区
const getSycCountyList = (data) => {
  return request.post('/api/wx/getSycCountyList', data)
}
// 理赔数据暂存
const saveTempData = (data) => {
  return request.post('/api/wx/auth/saveTempData', {
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 获取暂存数据
const getTempData = (data) => {
  return request.post(`/api/wx/auth/getTempData`, data, false)
}
// 对象数组
export default {
  getICalimsInfo,
  claimCancel,
  getAppDetilInfo,
  getClaimsDetail,
  calimApppatch,
  getPreAppbjFileList,
  getPrePatchFileType,
  queryClaimUploadedFiles,
  queryPreAuthUploadedFiles,
  getEobData,
  CgetServiceTemplate,
  CserviceSendMail,
  getCalimsAppPatchFileList,
  CgetTemplate,
  CSendMail,
  createIclaims,
  previewIclaims,
  getSycCtryList,
  getSycStateList,
  getSycDistList,
  getSycCountyList,
  saveTempData,
  getTempData
}
